import React from "react";
import {styled, TableCell, TableContainer} from "@mui/material";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import {convertDateToTimeString} from "../utils/cert-helper";
import KeyValuePair from "../utils/components/KeyValuePair";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
const StyledTableCell = styled(TableCell)({
    fontWeight: 'bold'
})
const StyledTypeAndActionSpan = styled('span') ({
    color: '#005cbfcc'
})
const StyledActionDurationSpan = styled('span') ({
    color: '#ff5722',
})


export default function AuditLogsAsList (props) {

    const auditLogs = props.auditLogs || [];

    const handleDescription = (description) => {
        if (description) {
            const desArr = description.split('|');
            return desArr.map((d, i) => (
                <li key={i} style={{color: '#334751'}}>{d}</li>
        ))
        } else {
            return "";
        }

    }

    return (
        <TableContainer sx={{mt: '10px'}}>
            <Table sx={{m: 0}}>
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Type / Action</StyledTableCell>
                        <StyledTableCell>Description / Action Duration</StyledTableCell>
                        <StyledTableCell sx={{ minWidth: '150px'}}>Time</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {auditLogs && auditLogs.map(a => (
                        <StyledTableRow key={a.id}>
                            <TableCell>
                                {a.hisp && <div>
                                    {/*HISP: <StyledTypeAndActionSpan>{a.hisp}</StyledTypeAndActionSpan>*/}
                                    <KeyValuePair name="HISP" value={a.hisp} />
                                </div>}
                                {/*TYPE: <StyledTypeAndActionSpan>{a.type}</StyledTypeAndActionSpan>*/}
                                <KeyValuePair name="TYPE" value={a.type} />
                                <br/>
                                {/*ACTION: <StyledTypeAndActionSpan>{a.action}</StyledTypeAndActionSpan>*/}
                                <KeyValuePair name="ACTION" value={a.action} />
                            </TableCell>
                            <TableCell>
                                {a.actionDuration !== 0
                                    ? <span>Action Duration: {a.actionDuration}<br/></span>
                                    : null
                                }
                                {a.description &&
                                    <ul style={{listStyle: 'none', paddingLeft: 0}}>
                                        {handleDescription(a.description)}
                                    </ul>
                                }
                            </TableCell>
                            {/*<TableCell sx={{ textAlign: 'center'}}>{a.actionDuration}</TableCell>*/}
                            <TableCell>{convertDateToTimeString(a.createdTs)}</TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )

}
